'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreFinder = function StoreFinder(el) {
  (0, _classCallCheck3.default)(this, StoreFinder);

  var google = window.google;
  var bounds = new google.maps.LatLngBounds();
  var maplis = {
    mapTypeId: 'roadmap',
    zoom: 4,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT
    },
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP
    },
    styles: [{
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{
        color: '#e9e9e9'
      }, {
        lightness: 17
      }]
    }, {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{
        color: '#f5f5f5'
      }, {
        lightness: 20
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#ffffff'
      }, {
        lightness: 17
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{
        color: '#ffffff'
      }, {
        lightness: 29
      }, {
        weight: 0.2
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [{
        color: '#ffffff'
      }, {
        lightness: 18
      }]
    }, {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [{
        color: '#ffffff'
      }, {
        lightness: 16
      }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{
        color: '#f5f5f5'
      }, {
        lightness: 21
      }]
    }, {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{
        color: '#dedede'
      }, {
        lightness: 21
      }]
    }, {
      elementType: 'labels.text.stroke',
      stylers: [{
        visibility: 'on'
      }, {
        color: '#ffffff'
      }, {
        lightness: 16
      }]
    }, {
      elementType: 'labels.text.fill',
      stylers: [{
        saturation: 36
      }, {
        color: '#333333'
      }, {
        lightness: 40
      }]
    }, {
      elementType: 'labels.icon',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{
        color: '#f2f2f2'
      }, {
        lightness: 19
      }]
    }, {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#fefefe'
      }, {
        lightness: 20
      }]
    }, {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [{
        color: '#fefefe'
      }, {
        lightness: 17
      }, {
        weight: 1.2
      }]
    }]

    // Display a map on the page
  };var map = new google.maps.Map(document.getElementById('map-Canvas'), maplis);
  map.setTilt(45);

  // Get the stores & data from shopify section information
  var stores = [];

  // Multiple Markers
  var markers = stores;

  // Loop through our array of markers & place each one on the map
  var shopsMarkers = [];
  var infowindows = [];

  // function addMarker ($this) {
  //   stores.push([
  //     $this.data('name'),
  //     $this.data('lat'),
  //     $this.data('lng'),
  //     $this.data('type'),
  //     $this.data('country')
  //   ])
  // }

  function getMarkers(region, type) {
    stores = [];
    if (region === 'all' && type === 'all') {
      (0, _jquery2.default)('.stf-Item_Row').each(function () {
        var $this = (0, _jquery2.default)(this);
        stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
      });
    } else if (region === 'all') {
      (0, _jquery2.default)('.stf-Item_Row').each(function () {
        var $this = (0, _jquery2.default)(this);
        if ($this.data('type') === type) {
          stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
        }
      });
    } else if (type === 'all') {
      (0, _jquery2.default)('.stf-Item_Row').each(function () {
        var $this = (0, _jquery2.default)(this);
        if ($this.data('country') === region) {
          stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
        }
      });
    } else {
      (0, _jquery2.default)('.stf-Item_Row').each(function () {
        var $this = (0, _jquery2.default)(this);
        if ($this.data('country') === region && $this.data('type') === type) {
          stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
        }
      });
    }

    return stores;
  }

  function removeMarkers(markersArray) {
    for (var i = 0; i < markersArray.length; i++) {
      markersArray[i].setMap(null);
    }
  }

  function setMarkers(locations) {
    var i = shopsMarkers.length;
    while (i--) {
      shopsMarkers.splice(i, 1);
    }

    var _loop = function _loop(_i2) {
      ;(function () {
        var j = _i2;
        var position = new google.maps.LatLng(locations[_i2][1], locations[_i2][2]);
        var category = locations[_i2][3];
        var region = locations[_i2][4];

        var icon = {
          url: 'https://cdn.shopify.com/s/files/1/0072/6961/3686/files/bao-pin_2x_b8f1ec1e-ad0d-4cf0-afda-e9e0c391c81e.png?13114746907672523329',
          size: new google.maps.Size(24, 30),
          scaledSize: new google.maps.Size(24, 30)
        };

        bounds.extend(position);
        shopsMarkers.push(new google.maps.Marker({
          position: position,
          map: map,
          category: category,
          title: locations[_i2][0],
          region: region,
          icon: icon
        }));

        infowindows[_i2] = new google.maps.InfoWindow({
          content: '<div class=\'marker-content\'>' + (0, _jquery2.default)('.stf-Item_Row .stf-Text_Name:contains(\'' + locations[_i2][0] + '\')').parent().html() + '</div>'
        });

        shopsMarkers[_i2].addListener('click', function () {
          for (_i2 = 0; _i2 < locations.length; _i2++) {
            infowindows[_i2].close();
          }
          infowindows[j].open(map, shopsMarkers[j]);
        });
      })();
      _i = _i2;
    };

    for (var _i = 0; _i < locations.length; _i++) {
      _loop(_i);
    }
  }

  setMarkers(getMarkers('all', 'all'));

  /**
   * Function to filter markers by category
   */

  // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
  var boundsListener = google.maps.event.addListener(map, 'bounds_changed', function (event) {
    this.setZoom(4);
    google.maps.event.removeListener(boundsListener);
  });
  var latLng = new google.maps.LatLng(53.112338, -2.669201); // Makes a latlng
  map.panTo(latLng); // Make map global

  // map jumping and showing stores in current countries
  var CountriesGeolocations = {
    UK: '53.112338, -2.669201',
    'Hong-Kong': '22.396427, 114.109497',
    Ireland: '53.412910, -8.243890',
    China: '35.861660, 104.195396',
    Australia: '-25.274399, 133.775131',
    Gibraltar: '36.140751, -5.353585',
    Thailand: '15.870032, 100.992538'

    /* Postcode search */
  };var inputAutocomplete = document.getElementById('inputAutocomplete');
  var autocomplete = new google.maps.places.Autocomplete(inputAutocomplete);

  var activeIcon = {
    url: 'https://cdn.shopify.com/s/files/1/0072/6961/3686/files/bao-pin-active_2x_f9a86f02-704b-49f3-b338-c8caf3ae8879.png?8295352510234515420',
    size: new google.maps.Size(24, 30),
    scaledSize: new google.maps.Size(24, 30)
  };

  autocomplete.bindTo('bounds', map);

  // Set the data fields to return when the user selects a place.
  autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

  var marker = new google.maps.Marker({
    map: map,
    icon: activeIcon,
    anchorPoint: new google.maps.Point(0, -29)
  });

  autocomplete.addListener('place_changed', function () {
    marker.setVisible(false);
    var place = autocomplete.getPlace();

    // If the place has a geometry, then present it on a map.
    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
      map.setZoom(9); // Why 17? Because it looks good.
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(9); // Why 17? Because it looks good.
    }
    marker.setPosition(place.geometry.location);
    marker.setVisible(true);
  });

  var calcDistance = function calcDistance(p1, p2) {
    return (google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000).toFixed(2) * 0.621371;
  };

  var hideInRadius = function hideInRadius(distance, shopsMarkers) {
    for (var i = 0; i < shopsMarkers.length; i++) {
      if (marker.getPosition()) {
        var distanceBetween = calcDistance(marker.getPosition(), shopsMarkers[i].getPosition());
        if (distanceBetween > distance) {
          shopsMarkers[i].setVisible(false);
        } else {
          shopsMarkers[i].setVisible(true);
        }
      }
    }
  };

  /* Click a link in the left column to reveal infowindow on the map */
  (0, _jquery2.default)('.stf-Row_Button').click(function (e) {
    var name = (0, _jquery2.default)(this).data('name');
    for (var i = 0; i < shopsMarkers.length; i++) {
      if (name === shopsMarkers[i].title) {
        google.maps.event.trigger(shopsMarkers[i], 'click');
      }
    }
  });

  //
  // /* Click a link in the left column to reveal infowindow on the map - Currently shows the last one */
  // $('.stf-Text_NameLink').click(function(e) {
  //   const name = $(this).data('name')
  //   for (let i = 0; i < shopsMarkers.length; i++) {
  //     if (name === shopsMarkers[i].title) {
  //       google.maps.event.trigger(shopsMarkers[i], 'click')
  //     }
  //   }
  // })

  (0, _jquery2.default)('.stf-SelectOption-selected').click(function () {
    var $this = (0, _jquery2.default)(this);
    (0, _jquery2.default)('.stf-Select_Options').not($this.parent().find('.stf-Select_Options')).slideUp(function () {});
    $this.parent().find('.stf-Select_Options').slideToggle();
  });

  (0, _jquery2.default)('.stf-Select_Option').click(function (e) {
    var name = (0, _jquery2.default)(this).data('name');
    var value = (0, _jquery2.default)(this).data('value');
    (0, _jquery2.default)(this).parent().parent().find('.stf-SelectOption-selected').data('value', value);
    (0, _jquery2.default)(this).parent().slideUp();

    var country = (0, _jquery2.default)('.stf-SelectOption-countrySelected').data('value');
    var type = (0, _jquery2.default)('.stf-SelectOption-typeSelected').data('value');
    var distance = (0, _jquery2.default)('.stf-SelectOption-distanceSelected').data('value');
    if ((0, _jquery2.default)(this).parent().attr('id') === 'distance' && distance !== 'all') {
      if (marker.getPosition()) {
        (0, _jquery2.default)('.stf-Item_Row').each(function () {
          var storeLat = (0, _jquery2.default)(this).data('lat');
          var storeLng = (0, _jquery2.default)(this).data('lng');
          var storeCord = new google.maps.LatLng(storeLat, storeLng);
          var distanceBetween = calcDistance(marker.getPosition(), storeCord);
          if (distanceBetween > distance) {
            (0, _jquery2.default)(this).attr('data-distance-show', 'false');
          } else {
            (0, _jquery2.default)(this).attr('data-distance-show', 'true');
          }
        });
      } else {
        (0, _jquery2.default)('#inputAutocomplete').focus();
        return;
      }
    }
    (0, _jquery2.default)(this).parent().parent().find('.stf-SelectOption-selected').text(name);
    (0, _jquery2.default)(this).parent().find('.stf-Select_Option').removeClass('stf-Select_Option-active');
    (0, _jquery2.default)(this).addClass('stf-Select_Option-active');

    (0, _jquery2.default)('.stf-Item_Row').hide();

    var typeProperties = void 0,
        countryProperties = void 0;
    var distanceProperties = '[data-distance-show="true"]';
    type === 'all' ? typeProperties = '' : typeProperties = '[data-type="' + type + '"]';
    country === 'all' ? countryProperties = '' : countryProperties = '[data-country="' + country + '"]';
    var filterProperties = typeProperties + countryProperties + distanceProperties;
    (0, _jquery2.default)('.stf-Item_Row' + filterProperties).show();
    if ((0, _jquery2.default)('.stf-Item_Row').length === (0, _jquery2.default)('.stf-Item_Row:hidden').length) {
      (0, _jquery2.default)('.stf-Item_Empty').removeClass('stf-Item_Empty-hidden');
    } else {
      (0, _jquery2.default)('.stf-Item_Empty').addClass('stf-Item_Empty-hidden');
    }
    if ((0, _jquery2.default)(this).parent().attr('id') === 'countries') {
      var _latLng = new google.maps.LatLng(53.112338, -2.669201); // Makes a latlng
      map.panTo(_latLng); // Make map global
      for (var key in CountriesGeolocations) {
        if (key === country) {
          var val = CountriesGeolocations[key];
          val = val.split(',');
          var _latLng2 = new google.maps.LatLng(val[0], val[1]); // Makes a latlng
          map.panTo(_latLng2); // Make map global
          break;
        }
      }
      map.setZoom(4);
    }
    removeMarkers(shopsMarkers);

    setMarkers(getMarkers(country, type));
    hideInRadius(distance, shopsMarkers);
  });
};

exports.default = StoreFinder;